import React from "react";
import { Routes, Route,  BrowserRouter } from "react-router-dom";
import Login from "../pages/ConfiguracoesSistema/Usuarios/Login/Login";
import WebAgendamento from "../WebsiteAgendamento/WebAgendamento";

const PublicRoutes = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/:teste" element={<WebAgendamento />} />
                <Route path="/login" element={<Login />} />
                <Route path="*" element={<Login />} />

            </Routes>
        </BrowserRouter>

    )
}
export default PublicRoutes;